export const mergeApiHandle = (data, datafield, dpapi, myapi) => {
  const addTrailingZeros = (value='') => {    
    if(!value) return '';
    value = value.toString();
    if(value.toString().includes(".")) {
      let count = value.split('.')[1].length;
      if(count === 1){
        return Number(value).toFixed(2);
      } else {
        return value;
      }
    } else return Number(value).toFixed(2);

  }
  
  let tempList = [];
  let generated = [];

  const pb = [],
    mi = [],
    ps = [],
    vd = [];
  let expandedGenerated = [];  

  if(dpapi[0].accountType === "Select") {
    data = data.map((item) => {
      if(item.title !== 'TIFF Multi-Asset Pool' && item.title !== 'Low Carbon Global Equity')
        item.title = `${item.title} ${dpapi[0].accountType}`;
      return item;
    })

    datafield = datafield.map((item) => {
      if(item.title !== 'TIFF Multi-Asset Pool' && item.title !== 'Low Carbon Global Equity')
        item.title = `${item.title} ${dpapi[0].accountType}`;
      return item;
    })
  }

  expandedGenerated = datafield.filter((obj) => {
    return obj.field_total === "No";
  });

  tempList = datafield.filter((obj) => {
    return obj.field_total === "Yes";
  });

  tempList.forEach((item) => {

    let tem = {};    
    tem.investmentOption = item.title;
    tem.nid = item.nid;
    tem.selExpRatio = addTrailingZeros(item.field_expense_ratio_select);
    tem.stdExpRatio = addTrailingZeros(item.field_expense_ratio_standard);
    tem.oneY = addTrailingZeros(item.field_returns_1_yr);
    tem.fiveY = addTrailingZeros(item.field_returns_5_yrs);
    tem.tenY = addTrailingZeros(item.field_returns_10_yrs);
    tem.returnsYTD = addTrailingZeros(item.field_returns_ytd);
    tem.field_total = item.field_total;
    tem.field_fund = item.field_fund;
    tem.isExpanded = false;        
    generated.push(tem);
  });

  generated.forEach((item) => {
    data.forEach((each) => {
      if (each.nid === item.nid) {
        item.label1 = each.field_target_allocation_label_1;
        item.value1 = each.field_target_allocation_value_1;
        item.label2 = each.field_target_allocation_label_2;
        item.value2 = each.field_target_allocation_value_2;
        item.benchmark = each.field_benchmark;
        item.description = each.field_description;
        item.goal = each.field_goal;
        item.management = each.field_management;
        item.risk = each.field_risk_granting;
      }
    });
  });


  generated.forEach((each) => {
    each.expandedData = [];
    expandedGenerated.forEach((item) => {
      if (each.nid === item.nid) {
        let tem = {};
        tem.investmentOption = item.title;
        tem.nid = item.nid;
        tem.selExpRatio = '';
        tem.stdExpRatio = '';
        tem.oneY = addTrailingZeros(item.field_returns_1_yr);
        tem.fiveY = addTrailingZeros(item.field_returns_5_yrs);
        tem.tenY = addTrailingZeros(item.field_returns_10_yrs);
        tem.returnsYTD = addTrailingZeros(item.field_returns_ytd);
        tem.field_total = item.field_total;
        tem.field_funds_percentage =item.field_funds_percentage;
        if (item.field_fund.includes("Benchmark Return")) {
          tem.field_fund = "Benchmark Return";
        } else {
          tem.field_fund = item.field_fund;
        }
        each.expandedData.push(tem);
      }
    });
  });  
  
  generated.forEach((each) => {
    if (myapi !== null && typeof myapi === 'object' && myapi.hasOwnProperty('length') && myapi.length > 0) {
      myapi[0].forEach((item) => {                
        if (
          item.poolName.toLowerCase() ===
          each.investmentOption.toLowerCase()
        ) {
          each.isMyInvestment = true;
          each.currentNAV = addTrailingZeros(item.currentNAV);
          each.priceTable = item.unitHistoricalNAV;
          each.poolId = item.poolId;
          each.availableBalance = item.availableBalance;
          each.currentBalance = item.currentBalance;
          each.availableUnits = item.availableUnits;
          each.date = item.dateOfPricePerUnit
        }
      });
    }

    dpapi[0].portfolioSolutions.forEach((item) => {
      if (
        item.investmentOption.toLowerCase() ===
        each.investmentOption.toLowerCase()
      ) {
        each.type = "ps";
        each.currentNAV = addTrailingZeros(item.currentNav);
        each.priceTable = item.unitHistoricalNAV;
        each.poolId = item.poolId;
        each.date = item.asOfDate
      }
    });    

    dpapi[0].portfolioBuilders.forEach((item) => {      
      if (
        item.investmentOption.toLowerCase() ===
        each.investmentOption.toLowerCase()
      ) {
        each.type = "pb";
        each.currentNAV = addTrailingZeros(item.currentNav);
        each.priceTable = item.unitHistoricalNAV;
        each.poolId = item.poolId;  
        each.date = item.asOfDate      
      }
    });

    dpapi[0].valueDriven.forEach((item) => {
      if (
        item.investmentOption.toLowerCase() ===
        each.investmentOption.toLowerCase()
      ) {
        each.type = "vdi";
        each.currentNAV = addTrailingZeros(item.currentNav);
        each.priceTable = item.unitHistoricalNAV;
        each.poolId = item.poolId;
        each.date = item.asOfDate
      }
    });   

  });

  const dataGenerator = generated => {
    generated.forEach((each) => {
      if (each.hasOwnProperty('isMyInvestment') && each.isMyInvestment === true) {
        mi.push(each);
      }
      if (each.type === "ps") {
        ps.push(each);
      }
      if (each.type === "pb") {
        pb.push(each);
      }
      if (each.type === "vdi") {
        vd.push(each);
      }
    });
  }; 

  dataGenerator(generated);

  let userData = JSON.parse(sessionStorage.getItem("primaryAccount"));  
    
  return {
    fundName: userData.accountName,
    fundId: userData.accountNumber,
    accountType: dpapi[0].accountType,
    fundData: {
      tab1: mi,
      tab2: ps,
      tab3: pb,
      tab4: vd
    }
  };
};